import React, { useEffect } from 'react';
import ReactDOMServer from 'react-dom/server';
import { useTranslation } from 'react-i18next';
import _isEmpty from 'lodash/isEmpty';
import {
  getFontFamilyByBrand,
  getIconPinByBrand,
  getLabelOriginByBrand,
  getWindowSizeByBrand,
} from '@/utils/Common/CustomOptionsMarker';
import CONST from '@/utils/Constants/General';
import { goToPage } from '@/utils/Common/Redirects';
import GoogleMarker from '@/components/organisms/GoogleMarker';
// import gtm stuff
import {
  pushGtmServiceLocatorGoogleMaps,
  pushGtmServiceLocatorVisitWebsite,
} from '@/utils/Controllers/GTM/Operations/ServiceLocator';

export default ({
  pos,
  markers,
  googleMap,
  setMarkers,
  googleMapJSLoaded,
  currentLatLng,
}) => {
  const { t } = useTranslation();

  const goToWebsite = url => {
    pushGtmServiceLocatorVisitWebsite();
    window.open(url);
  };

  const writeUs = email => {
    goToPage(`mailto:${email}`);
  };

  const goToMaps = (lat, lng) => {
    pushGtmServiceLocatorGoogleMaps();
    window.open(`https://maps.google.com/?daddr=${lat},${lng}`);
  };

  useEffect(() => {
    if (!googleMapJSLoaded) {
      return;
    }
    const boundsMap = new google.maps.LatLngBounds();
    Array.from(markers).forEach(marker => {
      marker.setMap(null);
    });
    const googleMarkers = pos.map((store, index) => {
      const position = new google.maps.LatLng(
        store.geoPoint.latitude,
        store.geoPoint.longitude,
      );

      const infoWindow = new google.maps.InfoWindow({
        content: ReactDOMServer.renderToString(
          <GoogleMarker store={store} t={t} />,
        ),
        maxWidth: getWindowSizeByBrand(),
      });

      const marker = new google.maps.Marker({
        map: googleMap,
        icon: {
          url: getIconPinByBrand(),
          labelOrigin: getLabelOriginByBrand(),
        },
        label: {
          text: (index + 1).toString(),
          color: CONST.COLOR.WHITE,
          fontFamily: getFontFamilyByBrand(),
        },
        borderRadius: 1,
        position,
        infoWindow,
      });

      google.maps.event.addListener(infoWindow, 'domready', () => {
        const btnUrl = document.getElementById(`js-r-website-${store.name}`);
        if (btnUrl)
          btnUrl.addEventListener('click', () =>
            goToWebsite(store.address.url),
          );
        const btnWrite = document.getElementById(`js-r-write-${store.name}`);
        if (btnWrite)
          btnWrite.addEventListener('click', () =>
            writeUs(store.address.email),
          );
        document
          .getElementById(`js-r-maps-${store.name}`)
          .addEventListener('click', () =>
            goToMaps(position.lat(), position.lng()),
          );
      });

      boundsMap.extend(position);
      return marker;
    });
    setMarkers(googleMarkers);

    googleMap.fitBounds(boundsMap); // set zoom automatically based on marker

    if (pos.length <= 1) {
      googleMap.setZoom(CONST.MAPS.Z10);
    }

    if (pos.length === 0) {
      googleMap.setCenter({
        lat: currentLatLng.latitude,
        lng: currentLatLng.longitude,
      });
    }
  }, [pos]);

  useEffect(() => {
    if (!_isEmpty(markers)) {
      Array.from(markers).forEach(marker => {
        google.maps.event.addListener(marker, 'click', () => {
          markers.map(m => m.infoWindow.close(googleMap, m));
          marker.infoWindow.open(googleMap, marker);
        });
      });
    }
  }, [markers]);
};
